var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2962 23.8566C46.2962 36.6115 35.9562 46.9514 23.2013 46.9514C10.4464 46.9514 0.106445 36.6115 0.106445 23.8566C0.106445 11.1016 10.4464 0.761719 23.2013 0.761719C35.9562 0.761719 46.2962 11.1016 46.2962 23.8566ZM23.2013 41.632C33.0184 41.632 40.9767 33.6736 40.9767 23.8566C40.9767 14.0395 33.0184 6.0812 23.2013 6.0812C13.3842 6.0812 5.42592 14.0395 5.42592 23.8566C5.42592 33.6736 13.3842 41.632 23.2013 41.632Z",
    fill: "#45B5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3463 29.6642L28.5667 24.3447C28.6258 24.2856 28.6849 24.2265 28.744 24.1674C28.9213 23.8719 28.8622 23.5172 28.5667 23.3399L19.3463 18.0204C19.2872 17.9022 19.169 17.9022 19.0507 17.9022C18.6961 17.9022 18.4597 18.1386 18.4597 18.4933L18.4597 29.1322C18.4597 29.2504 18.4597 29.3095 18.5188 29.4278C18.6961 29.7233 19.0507 29.7824 19.3463 29.6642Z",
    fill: "#45B5AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.a7d9e3a51158afe544f5a7813a4410b2.svg";
export { ForwardRef as ReactComponent };